import React from "react";

const Partnership = () => {
  return <>Partnership</>;
};

export default Partnership;